import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of, tap } from "rxjs";
import { AreaService } from "../../services/area.service";
import { findAreaAct, loadAreaByIdAct, saveAreaAct, saveSuccessAreaAct, setViolationsAreaAct, showMsgErrorAct, updateAreaAct, updateSuccessAreaAct } from "./area.actions";
import { AlertaService } from "../../services/alerta.service";

@Injectable()
export class AreaEffects {

    private actions$ = inject(Actions);
    private router = inject(Router);
    private areaService = inject(AreaService);
    private alerta = inject(AlertaService);

    /*CRUD CATALOG AREA*/
    /*getAllAreasCatalogEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(getAllAreasCatalogAct),
            exhaustMap(() => this.catalogService.getAllAreas()
        .pipe(
            map(areas => loadAllAreasCatalogAct({ areas })),
            catchError(error => of(error))
        ))
        )
    );*/

    findAreaEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(findAreaAct),
            exhaustMap(action => this.areaService.getAreaById(action.id)
        .pipe(
            map(area => loadAreaByIdAct({ area })),
            catchError(error => of(error))
        ))
        )
    );

    saveAreaEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(saveAreaAct),
            exhaustMap(action => this.areaService.saveArea(action.areaNew)
                .pipe(
                    map(areaNew => saveSuccessAreaAct({ areaNew })),
                    catchError(error => (error.status == 400) ? of(setViolationsAreaAct({ areaForm: action.areaNew, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))                        
                    )
                )
            )
        )
    );

    saveSuccessAreaEffect$ = createEffect(() => this.actions$.pipe(
        ofType(saveSuccessAreaAct),
        tap(() => {
            this.router.navigate(['/areas']);
                this.alerta.correct("Area creada con exito");
            })
        ), { dispatch: false }
    );

    updateAreaEffect$ = createEffect(
        () => this.actions$.pipe(
            ofType(updateAreaAct),
            exhaustMap(action => this.areaService.updateArea(action.areaUpdated)
                .pipe(
                    map(areaUpdated => updateSuccessAreaAct({ areaUpdated })),
                    catchError(error => (error.status == 400) ? of(setViolationsAreaAct({ areaForm: action.areaUpdated, violations: this.violationsToObject(error.error.parameterViolations) })) : of(showMsgErrorAct({ error }))
                    )
                )
            )
        )
    );
    
    updateSuccessAreaEffect$ = createEffect(() => this.actions$.pipe(
        ofType(updateSuccessAreaAct),
        tap(() => {
            this.router.navigate(['/areas']);
            this.alerta.correct("Area editada con exito");
        })
    ), {dispatch: false});
    /*CRUD CATALOG AREA END*/
    showMsgErrorEffect$ = createEffect(() => this.actions$.pipe(
        ofType(showMsgErrorAct),
            tap((action) => {
                this.alerta.error("Se ha precentado un error interno: ", {detail: action.error.message});
            })
        ), { dispatch: false }
    );
    
    violationsToObject(violationsList: []): any {
        return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
            //obj[item.field.slice(item.field.lastIndexOf('.') + 1)] = item.message;
            //obj[item.field.slice(item.field.indexOf('.') + 1).replaceAll('.', '_')] = item.message;                obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
            return obj;
        }, {});
    };
}